import socialsHandle from "fragments/socialsHandle"
import gql from "graphql-tag"

const SOCIALS_HANDLE_UPDATE = gql`
  ${socialsHandle}

  mutation socialsHandleUpdate(
    $socialsHandleUpdateInput: SocialsHandleUpdateInput!
  ) {
    socialsHandleUpdate(socialsHandleUpdateInput: $socialsHandleUpdateInput) {
      ...SocialsHandle
    }
  }
`

export default SOCIALS_HANDLE_UPDATE
